import { useEffect, useState } from "react";

export const ReadingProgress = ({ articleRef }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const updateProgress = () => {
      const article = articleRef.current;
      if (!article) return;
      const start = article.offsetTop;
      const available = Math.max(article.offsetHeight - window.innerHeight, 1);
      const nextProgress = Math.min(100, Math.max(0, ((window.scrollY - start) / available) * 100));
      setProgress(nextProgress);
    };

    updateProgress();
    window.addEventListener("scroll", updateProgress, { passive: true });
    window.addEventListener("resize", updateProgress);
    return () => {
      window.removeEventListener("scroll", updateProgress);
      window.removeEventListener("resize", updateProgress);
    };
  }, [articleRef]);

  return <div
    className="reading-progress-track"
    role="progressbar"
    aria-label="Article reading progress"
    aria-valuemin="0"
    aria-valuemax="100"
    aria-valuenow={Math.round(progress)}
    data-testid="article-reading-progress"
  >
    <span style={{ transform: `scaleX(${progress / 100})` }} data-testid="article-reading-progress-value" />
  </div>;
};